module.exports = __webpack_public_path__ + "static/media/icon-notarjetas.5552c8f5.svg";